export default "__VITE_ASSET__oF6bPXu2__"